import React from 'react';

export const RescheduleIcon = ({ fill = "#018100", width = 20, height = 20 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 122.88 121.52"
      width={width}
      height={height}
      fill={fill} // Apply the fill color
      role="img"
     
    >
    
      <path d="M50.43.09,77.25,0C82.1,0,85.4.86,88.58,5l7.57,13.52,7.68-4.74L90.6,36.93l-26.74-.1L72,32.09,58.26,8.77A25.12,25.12,0,0,0,54.12,3,22.45,22.45,0,0,0,50.43.09ZM56.9,112.26l-25.73,0c-5.69-.88-9.34-4-10.43-8.26-.93-3.71,0-5.42,1.6-8.61,1.93-3.81,4.2-7.49,6.38-11.2l28.49.1-.31,27.92Zm-41-10L2.43,79.06C0,74.87-.91,71.57,1.12,66.72L9.05,53.4,1.11,49.13,27.73,49,41,72.24l-8.19-4.71L19.52,91.12a24.94,24.94,0,0,0-3,6.49,22.15,22.15,0,0,0-.64,4.63Zm92.91-60.6,12.91,22.25C123.82,69.26,123,74,119.8,77.05c-2.74,2.67-4.69,2.73-8.26,2.93-4.26.23-8.58.1-12.89.07L84.49,55.33l24.34-13.69Zm11.81,40.5-13.33,23.27c-2.41,4.21-4.82,6.64-10,7.3l-15.5-.21.27,9-13.4-23L82.11,75.4l0,9.45,27.08-.27a25,25,0,0,0,7.1-.68,22.2,22.2,0,0,0,4.33-1.76ZM21.26,30.57,34.08,8.27c3.6-4.5,8.1-6.11,12.36-4.91,3.68,1.05,4.71,2.7,6.67,5.69,2.33,3.57,4.38,7.38,6.51,11.13L45.28,44.8l-24-14.23Z" />
    </svg>
  );
};


